import $foreign from "./foreign.cjs";
var ordArrayImpl = $foreign.ordArrayImpl;
var ordBooleanImpl = $foreign.ordBooleanImpl;
var ordCharImpl = $foreign.ordCharImpl;
var ordIntImpl = $foreign.ordIntImpl;
var ordNumberImpl = $foreign.ordNumberImpl;
var ordStringImpl = $foreign.ordStringImpl;
export { ordArrayImpl, ordBooleanImpl, ordCharImpl, ordIntImpl, ordNumberImpl, ordStringImpl };
